export const overrideColors = (data: any, colors?: string[]) => {
  if (!colors) return;
  if (data.type === "line" || data.type === "point") {
    data.element._node.setAttribute(
      "style",
      `stroke: ${colors[data.seriesIndex]};`
    );
  }
};
